import { IconProp } from '@fortawesome/fontawesome-svg-core';

import {
  faAngleDown,
  faAngleRight,
  faArrowCircleRight,
  faArrowDownToLine,
  faBadgeCheck,
  faBars,
  faBell,
  faBriefcase,
  faCaretDown,
  faCartShopping,
  faCartXmark,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCircleQuestion,
  faClock,
  faComments,
  faEnvelope,
  faExclamationCircle,
  faEye,
  faFile,
  faFileCad,
  faFilePdf,
  faFileVector,
  faGear,
  faHeadSideBrain,
  faHeart,
  faHeartbeat,
  faHouse,
  faLocationDot,
  faLongArrowAltLeft,
  faLongArrowAltRight,
  faMagnifyingGlass,
  faMap,
  faMapMarkedAlt,
  faMemo,
  faMinus,
  faNewspaper,
  faNotesMedical,
  faOctagonCheck,
  faOctagonExclamation,
  faOctagonXmark,
  faPlus,
  faRotate,
  faSave,
  faSignOutAlt,
  faTimes,
  faTimesCircle,
  faTrash,
  faTriangleExclamation,
  faTv,
  faUndo,
  faUser,
  faUsers,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faCalendarAlt,
  faCalendarEdit,
  faCog,
  faCommentDollar,
  faFileInvoiceDollar,
  faSearch,
  faUserCog,
  faUsersCog,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faTwitter,
  faVimeo,
  faXTwitter,
  faYoutube,
  faCcAmex,
  faCcDiscover,
  faCcMastercard,
  faCcVisa,
} from '@fortawesome/free-brands-svg-icons';

export const icons = {
  alertCircle: faExclamationCircle as IconProp,
  alerts: faBell as IconProp,
  angleDown: faAngleDown as IconProp,
  angleRight: faAngleRight as IconProp,
  arrowLeft: faLongArrowAltLeft as IconProp,
  arrowRight: faLongArrowAltRight as IconProp,
  badgeCheck: faBadgeCheck as IconProp,
  briefcase: faBriefcase as IconProp,
  calendar: faCalendarAlt as IconProp,
  calendarEdit: faCalendarEdit as IconProp,
  cart: faCartShopping as IconProp,
  cartEmpty: faCartXmark as IconProp,
  chat: faComments as IconProp,
  chevronLeft: faChevronLeft as IconProp,
  chevronRight: faChevronRight as IconProp,
  clock: faClock as IconProp,
  close: faTimes as IconProp,
  commentDollar: faCommentDollar as IconProp,
  delete: faTrash as IconProp,
  diagnosis: faHeadSideBrain as IconProp,
  distance: faMapMarkedAlt as IconProp,
  down: faChevronDown as IconProp,
  downArrow: faCaretDown as IconProp,
  download: faArrowDownToLine as IconProp,
  email: faEnvelope as IconProp,
  error: faTimesCircle as IconProp,
  facebook: faFacebookF as IconProp,
  file: faFile as IconProp,
  fileCad: faFileCad as IconProp,
  filePdf: faFilePdf as IconProp,
  fileVector: faFileVector as IconProp,
  gear: faGear as IconProp,
  heart: faHeart as IconProp,
  home: faHouse as IconProp,
  instagram: faInstagram as IconProp,
  linkedin: faLinkedinIn as IconProp,
  locationDot: faLocationDot as IconProp,
  magnify: faMagnifyingGlass as IconProp,
  map: faMap as IconProp,
  memo: faMemo as IconProp,
  menu: faBars as IconProp,
  minus: faMinus as IconProp,
  newsPaper: faNewspaper as IconProp,
  next: faArrowCircleRight as IconProp,
  octagonCheck: faOctagonCheck as IconProp,
  octagonExclamation: faOctagonExclamation as IconProp,
  octagonX: faOctagonXmark as IconProp,
  overview: faEye as IconProp,
  plus: faPlus as IconProp,
  question: faCircleQuestion as IconProp,
  refresh: faRotate as IconProp,
  reporting: faNotesMedical as IconProp,
  restore: faUndo as IconProp,
  revenue: faFileInvoiceDollar as IconProp,
  riskScore: faHeartbeat as IconProp,
  save: faSave as IconProp,
  search: faSearch as IconProp,
  settings: faCog as IconProp,
  signOut: faSignOutAlt as IconProp,
  success: faCheckCircle as IconProp,
  tv: faTv as IconProp,
  twitter: faTwitter as IconProp,
  twitterx: faXTwitter as IconProp,
  user: faUser as IconProp,
  userCog: faUserCog as IconProp,
  users: faUsers as IconProp,
  usersCog: faUsersCog as IconProp,
  vimeo: faVimeo as IconProp,
  warning: faTriangleExclamation as IconProp,
  youtube: faYoutube as IconProp,
  visa: faCcVisa as IconProp,
  amex: faCcAmex as IconProp,
  masterCard: faCcMastercard as IconProp,
  discover: faCcDiscover as IconProp,
};
